import { useTranslation } from "react-i18next";
import type { ContractStatusNotification as ContractStatusNotificationType } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type NotificationProps = {
  data: Pick<
    ContractStatusNotificationType,
    "contractNumber" | "customerName" | "customerRequestStatus"
  >;
};

const CustomerRequestNotification = (props: NotificationProps) => {
  const { data } = props;
  const { customerRequestStatus, customerName, contractNumber } = data;

  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t(
        `notifications.customer_request.${customerRequestStatus?.toLowerCase()}.title`,
        {
          customerName,
          contractNumber,
        }
      )}
    />
  );
};

export default CustomerRequestNotification;
